<template>
  <v-card flat>
    <v-card-title class="pa-0">
      <h4>Attribute Review</h4>
    </v-card-title>
    <v-card-text
      v-if="attributes.length === 0"
      key="no-attrs-to-review"
      class="px-0"
    >
      <p class="mb-0">This asset has no attributes to review</p>
    </v-card-text>
    <v-card-text v-else key="has-attrs-to-review" class="px-0">
      <p class="mb-0">
        Please review the attribute values below and make any desired changes
      </p>
      <div v-for="(attr, idx) in attributes" :key="idx">
        <v-text-field
          v-model="attr.newValue"
          :label="attr.name"
          :placeholder="`Please enter a value for '${attr.name}'`"
          :append-icon="SbIcons.entity.info"
          persistent-hint
          :hint="changeMessage(attr)"
          @input="$emit('updated', 'attribute', attr)"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * In this review step the owner can change attributes of the asset (e.g.
 * description)
 */
import reviewStepBase from './reviewStepBase.mixin.js';

export default {
  name: 'AssetReviewStepAttributes',
  mixins: [reviewStepBase],
  methods: {
    changeMessage(attribute) {
      if (attribute.value != attribute.newValue && attribute.newValue != '') {
        const originalValue = attribute.value ? `"${attribute.value}"` : 'None';
        return `Original value: ${originalValue}`;
      } else {
        return undefined;
      }
    },
  },
};
</script>

<style>
/*
Reduce the margin under the input so the hint text is grouped closer to the
input it refers to, instead of being equally spaced between the input it refers
to and the one below it
*/
.v-input__slot {
  margin-bottom: 3px;
}
</style>
